import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MailService {

  constructor(private http: HttpClient) { }

  GetEmailAddresses(memberlist: number[]) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    
    return this.http.post<any>(environment.apiUrl + 'Email/GetMemberEmail', JSON.stringify(memberlist), httpOptions);
  }

  SendEMail(maildata: FormData) {
    return this.http.post<any>(environment.apiUrl + 'Email/SendEmail', maildata);
  }

  /*addRecipientsToCampaign(data: { CampaignId: string, ToAddresses: string[], MemberIdList: number[] }) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    
    return this.http.post<any>(environment.apiUrl + 'Email/AddRecipientsToCampaign', JSON.stringify({ campaignId, recipients, memberidlist }), httpOptions);
  }*/

   addRecipientsToCampaign(campaignData: any) {  
     return this.http.post<any>(environment.apiUrl + 'Email/AddRecipientsToCampaign', campaignData);
  }

}